import styled from 'styled-components';

import * as mixin from '@wconcept/wconcept-ui/styles/mixin';

interface IProps {
  $btnType?: string;
}

export const NoticeModal = styled.div<IProps>`
  height: 100%;
  border-radius: ${mixin.pxToVw('20 20 0 0')};
  position: relative;
  background: #fff;
  z-index: 0;

  &.is-old-app-iphonex {
    .area-btn {
      padding-bottom: 30px;
    }
  }

  .title {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    text-align: center;
    background: transparent;

    + .content {
      padding-bottom: ${mixin.pxToVw('40')};
    }
  }

  .desc + .content-item {
    margin-top: ${mixin.pxToVw('30')};
  }

  .share-btn {
    width: ${mixin.pxToVw('38')};
    height: ${mixin.pxToVw('38')};
    margin: ${mixin.pxToVw('0 14')};

    svg {
      width: 100%;
      height: 100%;
    }
  }

  .notice-wrap {
    font-size: ${mixin.pxToVw('14')};
    line-height: ${mixin.pxToVw('20')};
    text-align: left;
    color: #262626;

    p + ul {
      margin-top: ${mixin.pxToVw('10')};
    }

    ul {
      li {
        position: relative;
        padding-left: ${mixin.pxToVw('9')};

        strong {
          font-family: ${({ theme }) => theme.fontFamily.semibold};
          font-weight: 500;
          font-size: ${mixin.pxToVw('16')};
        }

        &:after {
          content: '';
          display: block;
          position: absolute;
          top: ${mixin.pxToVw('8')};
          left: 0;
          width: ${mixin.pxToVw('3')};
          height: ${mixin.pxToVw('3')};
          border-radius: 50%;
          background: #262626;
        }

        + li {
          margin-top: ${mixin.pxToVw('10')};
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.sm} {
    border-radius: 20px 20px 0 0;

    .title {
      + .content {
        padding-bottom: 40px;
      }
    }

    .desc + .content-item {
      margin-top: 30px;
    }

    .share-btn {
      width: 38px;
      height: 38px;
      margin: 0 14px;
    }

    .notice-wrap {
      font-size: 14px;
      line-height: 20px;

      p {
        word-break: keep-all;
        overflow-wrap: break-word;

        + ul {
          margin-top: 10px;
        }
      }

      ul {
        li {
          padding-left: 9px;

          strong {
            font-size: 16px;
          }

          &:after {
            top: 8px;
            width: 3px;
            height: 3px;
          }

          + li {
            margin-top: 10px;
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.xl} {
    width: ${({ $btnType }) => ($btnType === 'single' ? '450px' : '640px')};
    border-radius: 0;
    padding: 40px 40px 50px;
    border: 1px solid #000;

    .title {
      position: static;
      text-align: left;
      font-size: 24px;
      line-height: 30px;
      padding-bottom: 30px;
      border-bottom: 2px solid #000;

      + .content {
        padding: 30px 0;
      }
    }

    .desc {
      font-size: 18px;
    }

    .btn-close {
      position: absolute;
      top: 40px;
      right: 40px;
    }

    .notice-wrap {
      font-size: 14px;
      line-height: 22px;

      p {
        color: #333;

        + ul {
          margin-top: 20px;
        }
      }

      ul {
        li {
          padding-left: 8px;
          color: #000;

          strong {
            font-size: 16px;
          }

          &:after {
            top: 10px;
            width: 2px;
            height: 2px;
          }

          + li {
            margin-top: 10px;
          }
        }
      }
    }
  }
`;

export const BoxCont = styled.div`
  text-align: center;
  padding: ${mixin.pxToVw('70 20')};

  @media ${({ theme }) => theme.media.sm} {
    padding: 70px 20px;
  }

  @media ${({ theme }) => theme.media.xl} {
    padding: 47px 0 50px;
  }
`;

export const BtnBox = styled.div`
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  text-align: center;

  .btn {
    font-size: ${mixin.pxToVw('16')};
    line-height: ${mixin.pxToVw('18')};
    height: ${mixin.pxToVw('50')};
    font-weight: 500;
    font-family: ${({ theme }) => theme.fontFamily.medium};

    &.btn-close {
      color: #333;
      background: #fff;
    }

    &.btn-submit {
      color: #fff;
      background: #000;
    }
  }

  &.single {
    border-top: 1px solid #eaeaea;

    .btn.btn-submit {
      width: 100%;
      color: #000;
      background: #fff;
    }
  }

  &.double {
    border-top: 1px solid #eaeaea;
    .btn {
      width: 50%;
    }
  }

  @media ${({ theme }) => theme.media.sm} {
    .btn {
      font-size: 16px;
      line-height: 18px;
      height: 50px;
    }
  }

  @media ${({ theme }) => theme.media.xl} {
    .btn {
      width: 140px !important;
      height: 40px;
      font-size: 14px;

      &.btn-close {
        border: 1px solid #000;
      }
    }

    &.single {
      border: none;

      .btn.btn-submit {
        background: #000;
        color: #fff;
      }
    }

    &.double {
      padding-top: 30px;

      .btn {
        position: static;
        margin: 0 7.5px;
      }
    }
  }
`;
